import {
  ViveApiBaseService,
  ViveApiRequestOptions
} from './vive-api-base.service';
import {
  CompanyBlocklistedTaxIdDto,
  CompanyBlocklistedTaxIdsCreateRequestDto
} from './vive-api-models';

class CompanyBlocklistedTaxIdsService extends ViveApiBaseService {
  public async findAllByCompanyId(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
  }): Promise<CompanyBlocklistedTaxIdDto[]> {
    const { options, pathParams } = params;
    return await this.sendGet<CompanyBlocklistedTaxIdDto[]>({
      apiEndpoint: 'companies/:companyId/blocklisted-tax-ids',
      options,
      pathParams
    });
  }

  public async create(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number };
    data: CompanyBlocklistedTaxIdsCreateRequestDto;
  }): Promise<CompanyBlocklistedTaxIdDto> {
    const { options, pathParams, data } = params;
    return await this.sendPost<CompanyBlocklistedTaxIdDto>({
      apiEndpoint: 'companies/:companyId/blocklisted-tax-ids',
      options,
      pathParams,
      data
    });
  }

  public async deleteById(params: {
    options?: ViveApiRequestOptions;
    pathParams: { companyId: number; id: number };
  }): Promise<void> {
    const { options, pathParams } = params;
    await this.sendDelete<void>({
      apiEndpoint: 'companies/:companyId/blocklisted-tax-ids/:id',
      options,
      pathParams
    });
  }
}

export const companyBlocklistedTaxIdsService =
  new CompanyBlocklistedTaxIdsService();
